import styled from "styled-components";
import { Colors } from "../config";
import { SectionHeading, SectionContent } from "../config/StyledComponents";
import { PassportExpiry } from "../pages/MyProfile";
import { isValidUrl } from "../helper";

const ResponsiveTable = ({ columns, data }) => {
  return data?.map((item) => {
    return (
      <>
        <Wrapper>
          {columns?.map((column, index) => (
            <HeadingContentWrapper key={index + 1}>
              <SectionHeading>{column.label}</SectionHeading>
              {column.path !== "passportExpirationDate" ? (
                column.path === "passportPdf" ? (
                  <>
                    {isValidUrl(item?.passportPdf) ? (
                      <a href={item?.passportPdf}>
                        {item.firstName.toLowerCase()}.pdf
                      </a>
                    ) : (
                      "Not Available"
                    )}
                  </>
                ) : (
                  <SectionContent>{item[column.path]}</SectionContent>
                )
              ) : (
                <PassportExpiry
                  color={
                    new Date(item.passportExpirationDate) > new Date()
                      ? "black"
                      : "red"
                  }
                >
                  {item[column.path]}
                </PassportExpiry>
              )}
            </HeadingContentWrapper>
          ))}
        </Wrapper>
        <HorizontalLine />
      </>
    );
  });
};

const Wrapper = styled.div`
  padding-top: 1.125rem;
  display: grid;
  gap: 1rem;

  @media only screen (max-width: 480px) {
    grid-template-columns: 1fr;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 769px) {
    display: none;
  }
`;

const HorizontalLine = styled.hr`
  margin: 1.688rem 0rem 0.563rem;
  opacity: 0.1;
  border: 1px solid ${Colors.black};

  @media (min-width: 769px) {
    display: none;
  }

  &:last-child {
    display: none;
  }
`;

const HeadingContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export default ResponsiveTable;
